import React from 'react';
import hoistStatics from 'hoist-non-react-statics';

const trackingId = process.env.REACT_APP_GA_TRACKING_ID;

const _gtag = (...args) => {
  if (!window.gtag) {
    console.error('Google Analytics has not been initialized');
    return;
  }

  return window.gtag(...args);
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
const pageview = (path, location, title) => {
  if (!path || path === '') {
    console.error('path is required in .pageview()');
    return;
  }

  const params = { page_path: path };

  if (location) params.page_location = location;
  if (title) params.page_title = title;

  _gtag('config', trackingId, params);
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/screens
const screenview = name => {
  if (!name || name === '') {
    console.error('name is required in .screenview()');
    return;
  }

  _gtag('event', 'screen_view', { 'screen_name': name });
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
const event = (action, category, label, value) => {
  if (!action || action === '') {
    console.error('action is required in .event()');
    return;
  }

  const params = {};

  if (category) params.event_category = category;
  if (label) params.event_label = label;
  if (value) params.value = value;

  _gtag('event', action, params);
};

//
// Google Analytics HOC
// Usage: withGA(Component)
//
const withGA = Component => {
  const C = props => {
    return <Component {...props}
      gtag={{
        pageview,
        screenview,
        event
      }} />
  }

  C.displayName = `withGA(${Component.displayName || Component.name})`;
  C.WrappedComponent = Component;

  // https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
  return hoistStatics(C, Component);
}

export default withGA



// WEBPACK FOOTER //
// ./src/components/withGA/index.js